import classNames from 'classnames';
import { IButton } from './IButton';

interface IDefaultButton extends IButton {
  className?: string;
}

const DefaultButton = (props: IDefaultButton) => {
  const { handleOnClick, children, width, height, disabled, title, hidden, type, className } = props;

  return (
    <button
      style={{ width: width || 'auto', height: height || 'auto' }}
      className={classNames(
        { '!h-fit': !height },
        'rounded-full border-[1px] border-default bg-white px-3 py-2 font-bold !leading-none text-default-font-color transition-shadow ease-in hover:shadow-md md:px-4 lg:px-6',
        { 'cursor-not-allowed opacity-50': disabled },
        className
      )}
      onClick={handleOnClick}
      disabled={disabled}
      hidden={hidden}
      title={title}
      type={type}
    >
      {children}
    </button>
  );
};

export default DefaultButton;
